import { BlogSection } from "@/types/blog";

export const psychologischeSicherheit: BlogSection = {
  id: "psychologische-sicherheit",
  title: "Psychologische Sicherheit als Fundament",
  content: `
    <p>Menschen arbeiten dann gut, wenn sie sich sicher fühlen.</p>

    <p>Sicher, Fragen zu stellen.<br/>
    Sicher, Fehler einzugestehen.<br/>
    Sicher, anderer Meinung zu sein.</p>

    <p>Im Alltag zeigt sich das oft unspektakulär.<br/>
    Zum Beispiel in Sätzen wie:</p>

    <blockquote>
      <p><em>Was brauchst du gerade, um gut arbeiten zu können?</em></p>
      <p><em>Wo hakt es wirklich?</em></p>
      <p><em>Was habe ich vielleicht übersehen?</em></p>
    </blockquote>

    <p>Solche Fragen öffnen Räume. Kontrolle schließt sie.</p>

    <p>Amy Edmondson konnte zeigen, dass genau dieses Klima der stärkste Treiber für Lernen und Innovation in Teams ist.</p>
  `
};
